import React, { useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import {Button } from '@material-ui/core';
import apiService from '../../services/apiService';
import AuthContext from '../AppAuthContext';
import { checkIfAppNameExists, checkIfAppNameHasSpaces } from '../../validations/validations';

const FunctionsBarCreateProject = (props) => {
  const {
    appName,
    description,
    colorTheme,
    typeApp,
    fontType,
    invitedlist,
    isEdit,
    lock,
    setLock,
    selectedDuplicatedProject
  } = props;

  const navigate = useNavigate();
  const { state, dispatch } = useContext(AuthContext);
  const location = useLocation();

  useEffect(() => {
    let currentId = -1;
    if (location.state.project !== undefined) {
      currentId = location.state.project._id;
    }

    if (
      appName === '' ||
      checkIfAppNameExists(isEdit, currentId, appName) === true ||
      checkIfAppNameHasSpaces(appName)
    ) {
      setLock(true);
    } else if (description === '') {
      setLock(true);
    } else if ( location.state.reason === 'duplicate' && selectedDuplicatedProject === 'none'){
      setLock(true);
    }
    else {
      setLock(false);
    }
  }, [appName, description, typeApp,selectedDuplicatedProject]);

  const createBlankProject = () => {
    
    const newProject = {
      name: appName,
      color_theme: colorTheme,
      description,
      type_app: typeApp,
      type_font: fontType,
      invited_people: invitedlist,
      owner: state.user._id,
      pages: [],
      services: [],
      data_elements: { data_elements_blocks: [], data_elements_info: [] },
      customBlocks: [],
      annotations: [],
      date: (new Date().toLocaleString("en-GB")).toString()
    };
    return newProject;
  }

  const createDuplicateProject = async () => {

    const basedOnProject = JSON.parse(localStorage.getItem('data')).filter( project => project.name === selectedDuplicatedProject).map( project => project)[0];
    const pagesIds = basedOnProject.pages;

    return apiService
    .createDuplicatePages(pagesIds)
    .then(response => {

      const newDuplicatedProject = {
        name: appName,
        color_theme: basedOnProject.color_theme,
        description,
        type_app: basedOnProject.type_app,
        type_font: basedOnProject.type_font,
        invited_people: [],
        owner: state.user._id,
        pages: response.data,
        services: basedOnProject.services,
        data_elements: basedOnProject.data_elements,
        customBlocks: basedOnProject.customBlocks,
        annotations: basedOnProject.annotations,
        date: (new Date().toLocaleString("en-GB")).toString()
      };
      return newDuplicatedProject;
    })
    .catch( err => {
      throw(err);
    })

  }

  const createProject = async () => {

    // Clear local storage before creating a new project
    localStorage.removeItem('gjs-styles');
    localStorage.removeItem('gjs-assets');
    localStorage.removeItem('gjs-html');
    localStorage.removeItem('gjs-css');
    localStorage.removeItem('gjs-components');

    let newProject = {};

    if(location.state.reason === 'new'){
      newProject = createBlankProject();
    }
    else if (location.state.reason === 'duplicate'){
      newProject =  await createDuplicateProject();
    }

    const tempLocalStorage = JSON.parse(localStorage.getItem('data'));
    apiService.createProject(newProject).then((response) => {
      tempLocalStorage.push(response.data);
      localStorage.setItem('data', JSON.stringify(tempLocalStorage));
      navigate('/build_apps', { state: { name: appName, selectedPage: -1 } });
    });

  };

  const navigateToHome = () => {
    navigate('/');
  };

  const updateProject = () => {
    if (lock === false) {
      const tempProject = location.state.project;
      tempProject.name = appName;
      tempProject.description = description;
      tempProject.type_app = typeApp;
      tempProject.date =  (new Date().toLocaleString("en-GB")).toString();

      const currentId = location.state.project._id;

      const tempData = JSON.parse(localStorage.getItem('data'));
      tempData.forEach((project, indexProject) => {
        if (currentId === project._id) {
          tempData[indexProject].name = appName;
          tempData[indexProject].description = description;
          tempData[indexProject].type_app = typeApp;
          tempData[indexProject].date = (new Date().toLocaleString("en-GB")).toString();
        }
      });

      localStorage.setItem('data', JSON.stringify(tempData));

      apiService.updateProject(tempProject, dispatch);

      setTimeout(() => {
        navigate('/');
      }, 500);
    }
  };

  return (
      <div
        style={{
          position: 'absolute',
          bottom: '0',
          marginBottom: '2vw',
          width: '60%',
          justifyContent: 'space-between'
        }}
        className={clsx('flexRowDirection')}
      >
        <div className={clsx('flexRowDirection')}>
            <Button
              onClick={navigateToHome}
              style={{
                backgroundColor: '#FFFFFF',
                color: '#0C4D82',
                borderStyle: 'solid',
                borderColor: '#0C4D82',
                borderWidth: 2,
                height: '95%',
                width: '95%'
              }}
              color="primary"
              variant="contained"
            >
              Cancel
            </Button>
        </div>
        <div>
          <Button
            id="nextButton"
            variant="contained"
            color="primary"
            onClick={
              isEdit === true
                ? updateProject
                : createProject
            }
            style={{
                    backgroundColor: '#0C4D82',
                    borderColor: '#CFD8E0'
                  }}
          >
            {isEdit === true ? 'Update' : 'Finish' }
          </Button>
        </div>
      </div>
  );
};

export default FunctionsBarCreateProject;
